
var moment = require('moment');

module.exports = {
    bindings: {
        updateQueryString: '<'
    },
    controller: customsRulingsSearchFormController,
    templateUrl: 'cross/components/customs-rulings-search-form.html'
}

customsRulingsSearchFormController.$inject = [
    '$analytics', 
    '$location', 
    'crossDataService'
];

function customsRulingsSearchFormController(
    $analytics, 
    $location, 
    crossDataService
) {
    var vm = {
        $onInit: attached,
        changeSubjectQuery: changeSubjectQuery,
        changeTextQuery: changeTextQuery,
        clearCommodityCode: clearCommodityCode,
        clearRulingNumber: clearRulingNumber,
        clearSubjectQuery: clearSubjectQuery,
        clearTextQuery: clearTextQuery,
        filter: crossDataService.filter,
        service: crossDataService,
        isLoading: false,
        rulingDateFromDatepicker: {
            date: moment(crossDataService.filter.rulingDateFrom, "YYYY-MM-DD").toDate(),
            dateChanged: rulingDateFromDateChanged,
            blur: rulingDateFromBlur,
            opened: false,
            open: openRulingDateFromDatePicker,
            dateOptions: {}
        },
        rulingDateToDatepicker: {
            date: moment(crossDataService.filter.rulingDateTo, "YYYY-MM-DD").toDate(),
            dateChanged: rulingDateToDateChanged,
            blur: rulingDateToBlur,
            opened: false,
            open: openRulingDateToDatePicker,
            dateOptions: {}
        },
        loadNew: loadNew,
    };

    function attached() {
        if (crossDataService.filter.subjectQuery) {
            crossDataService.orderBy = 'SubjectRank-desc';
        }
    }
    
    function clearRulingNumber() {
        crossDataService.filter.rulingNumber = '';
    }

    function clearCommodityCode() {
        crossDataService.filter.goodsCode = '';
    }


    function changeTextQuery() {
        if (crossDataService.filter.textQuery && crossDataService.orderBy !== 'TextRank-desc' ) {
            if (crossDataService.filter.subjectQuery && crossDataService.orderBy === 'SubjectRank-desc') {
                // If the user has entered a keyword search query and we're ordering by that, don't override the ordering.
            }
            else {
                crossDataService.orderBy = 'RulingDate-desc';
            }
        }
    }

    function clearTextQuery() {
        crossDataService.filter.textQuery = '';
    }

    function changeSubjectQuery() {
        if (crossDataService.filter.subjectQuery && crossDataService.orderBy !== 'SubjectRank-desc') {
            if (crossDataService.filter.textQuery && crossDataService.orderBy === 'TextRank-desc') {
                // If the user has entered a goods description search query and we're ordering by that, don't override the ordering.
            }
            else {
                crossDataService.orderBy = 'RulingDate-desc';
            }
        }
    }

    function clearSubjectQuery() {
        crossDataService.filter.subjectQuery = '';
    }

    function rulingDateFromBlur() {
        if (!vm.rulingDateFromDatepicker.date) {
            vm.filter.rulingDateFrom = null;
        }
    }

    function rulingDateToBlur() {
        if (!vm.rulingDateToDatepicker.date) {
            vm.filter.rulingDateTo = null;
        }
    }

    function rulingDateFromDateChanged() {
        if (vm.rulingDateFromDatepicker.date) {
            var newDate = moment(vm.rulingDateFromDatepicker.date).format("YYYY-MM-DD");
            if (newDate !== vm.filter.rulingDateFrom) {
                vm.filter.rulingDateFrom = newDate;
            }
        }
        else {
            vm.filter.rulingDateFrom = null;
        }
    }

    function rulingDateToDateChanged() {
        if (vm.rulingDateToDatepicker.date) {
            var newDate = moment(vm.rulingDateToDatepicker.date).format("YYYY-MM-DD");
            if (newDate !== vm.filter.rulingDateTo) {
                vm.filter.rulingDateTo = newDate;
            }
        }
        else {
            vm.filter.rulingDateFrom = null;
        }
    }

    function openRulingDateFromDatePicker() {
        vm.rulingDateFromDatepicker.opened = true;
    }

    function openRulingDateToDatePicker() {
        vm.rulingDateToDatepicker.opened = true;
    }

    if (vm.updateQueryString) {
        updateSearchQuery();
    }

    return vm;

    function loadNew() {
        $analytics.pageTrack('/customs-rulings-search');
        if (vm.updateQueryString) {
            updateSearchQuery();
        }
        vm.isLoading = true;
        crossDataService.loadNewRulings()
            .then(function () {
                vm.isLoading = false;
            });
    }

    function updateSearchQuery() {
        $location.search('query', vm.filter.subjectQuery);
        $location.search('commodityCode', vm.filter.goodsCode);
    }
}